import actions from "@/core/store/modules/notification/actions";
import getters from "@/core/store/modules/notification/getters";
import mutations from "@/core/store/modules/notification/mutations";


export default {
    state: {
        notifications: {},
        groups: {},
        menu_badge_counter: {},
        total: 0
    },
    getters,
    mutations,
    actions
}